// extracted by mini-css-extract-plugin
export default {"clickableCard":"ResultItem_clickableCard__uRdMd","icon":"ResultItem_icon__2Xe5w","name":"ResultItem_name__CgI6t","date":"ResultItem_date__v4brC","venue":"ResultItem_venue__Y+jBs"};